import React from "react";
import bannerImage from "../assets/images/Herosection/herobanner.jpg"; // change path if needed

const PageBanner = ({ title, subtitle }) => {
  // Br and Color Palette mapped exactly from the logo
  const COLORS = {
    red: "#9B1B22",       // Deep Crimson Red (from logo)
    cream: "#FAF7F2",     // Premium Cream (from logo background)
    gold: "#D4AF37",      // Luxury Gold (from logo text/accents)
    textDark: "#1A1A1A",  // Deep Charcoal
    textLight: "#FFFFFF", // Pure White
  };

  return (
    <section className="relative w-full h-[300px] md:h-[350px] lg:h-[400px] flex items-center justify-center font-serif overflow-hidden bg-[#1A1A1A]">
      
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={bannerImage}
          alt="Banner"
          // Grayscale allows the br and colors to dictate the mood without clashing
          className="w-full h-full object-cover grayscale opacity-80"
        />

        {/* Br and Gradient Overlay: Deep Crimson Red blending into Dark Charcoal */}
        <div 
          className="absolute inset-0"
          style={{
            background: `linear-gradient(135deg, ${COLORS.red}E6 0%, #1A1A1AE6 100%)` // E6 adds ~90% opacity to the hex colors
          }}
        ></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto flex flex-col items-center">
        
        {/* Subtitle */}
        {subtitle && (
          <div className="flex items-center gap-4 mb-5">
            <div className="w-10 h-[1px]" style={{ backgroundColor: COLORS.gold }}></div>
            <p
              className="uppercase tracking-[0.4em] text-xs font-bold"
              style={{ color: COLORS.gold }}
            >
              {subtitle}
            </p>
            <div className="w-10 h-[1px]" style={{ backgroundColor: COLORS.gold }}></div>
          </div>
        )}

        {/* Title */}
        <h1 
          className="text-4xl md:text-5xl lg:text-6xl font-bold uppercase tracking-widest leading-tight mb-8"
          style={{ color: COLORS.textLight }}
        >
          {title}
        </h1>

        {/* Gold Accent Element */}
        <div
          className="w-20 h-[3px] rounded-full"
          style={{ backgroundColor: COLORS.gold }}
        ></div>

      </div>

      {/* Background Watermark */}
      <div className="absolute bottom-[-10%] left-0 w-full text-center pointer-events-none select-none overflow-hidden">
        <span 
          className="text-[12vw] font-bold uppercase block tracking-widest whitespace-nowrap opacity-[0.08]"
          style={{ color: COLORS.textLight }}
        >
          R & P Law Partners
        </span>
      </div>

      {/* Bottom Cream Trim (Creates a seamless transition to the page content below) */}
      <div 
        className="absolute bottom-0 left-0 w-full h-1.5"
        style={{ backgroundColor: COLORS.cream }}
      ></div>

    </section>
  );
};

export default PageBanner;